// @flow

const Cookies = require('cookies-js');

export default {
  saveToken(payload: {token: string, refreshToken?: string}) {
    Cookies.set('token', payload.token, {expires: Infinity});
    Cookies.set('refreshToken', payload.refreshToken, {expires: Infinity});
  },
  removeToken() {
    Cookies.expire('token');
    Cookies.expire('refreshToken');
  },
  getToken() {
    return {
      token: Cookies.get('token'),
      refreshToken: Cookies.get('refreshToken'),
    };
  },
};
